// https://deo.shopeesz.com/shopee/shopee-seller-live-sg/tsp/api/
// https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/tsp/api/
var getSuffix = function (env, sep) { return ['live', 'stable'].includes(env) ? '' : sep + 'nonlive'; };
export var apiBase = function (env, cn) {
    var s = getSuffix(env, '/');
    return "https://seller." + (cn ? 'sg.shopee.cn' : 'shopee.sg') + "/api/tsp" + s;
};
export var cdnBase = function (env, cn) {
    var s = getSuffix(env, '-');
    return "https://deo.shopee" + (cn ? 'sz' : 'mobile') + ".com/shopee/shopee-seller-live-sg/tsp/api" + s;
};
//# sourceMappingURL=live.js.map